import { get } from "lodash-es";
import Blue from "~/core";

new Blue({
    name: 'Form Validate',
    selector: ".form--validate",
    setup(form) {
        this.$validate(form);
    }
});


new Blue({
    name: 'Landing Page Form',
    selector: ".form--landing-page",
    setup(form) {
        const stepCount = form.querySelector('.form__step-increment');
        const steps = [...form.querySelectorAll('.form__step')];
        const totalSteps = steps.length;
        const eventString = 'click.prevent enter.prevent'
        const url = form.querySelector('#apiUrl') ? form.querySelector('#apiUrl').value : null;
        const successMessage = form.querySelector('.form__confirmation');
        const errorMessage = form.querySelector('.form__error');
        const formTitle = form.querySelector('.form__title')
        const phoneNumber = form.querySelector('#phone');
        const textMessages = form.querySelector('.text__messages');
        const rdoTextOptInNo = form.querySelector('#rdoOptInNo-textOptInNo') ? form.querySelector('#rdoOptInNo-textOptInNo') : null;

        const landingPageForm = form.querySelector('form#landingPage');
        const formElements = landingPageForm ? [...landingPageForm.elements].filter(el => !['submit', 'button', 'fieldset'].includes(el.type)) : null;

        let currentStep = 0;
        let nextStep;

        steps.forEach((step, i) => {
            const prevBtn = step.querySelector('.form__back-btn');
            const nextBtn = step.querySelector('.form__next-btn');
            const submitBtn = step.querySelector('.form__input--submit');
            const validationBtn = nextBtn ? nextBtn : submitBtn;

            if (currentStep === (steps.length - 1) && textMessages !== undefined && textMessages !== null) {
                textMessages.style.display = 'none';
                rdoTextOptInNo.checked = true;
            }

            const goToPrev = () => {
                nextStep = currentStep - 1;
                if (nextStep < 0) return;
                steps[currentStep].classList.remove('is-active');
                steps[nextStep].classList.add('is-active');
                currentStep = nextStep;
                stepCount.textContent = currentStep + 1;
                window.scroll({
                    top: steps[nextStep].offsetTop - 150,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            const goToNext = () => {
                nextStep = currentStep + 1;
                if (nextStep >= totalSteps) return;
                steps[currentStep].classList.remove('is-active');
                steps[nextStep].classList.add('is-active');
                currentStep = nextStep;
                stepCount.textContent = currentStep + 1;
                window.scroll({
                    top: steps[nextStep].offsetTop - 150,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            const getJsonData = () => {
                const formData = [];
                const communities = [];

                formElements.forEach(el => {
                    const id = el.id;
                    const name = el.name;
                    let value = el.value.trim();
                    if (el.hasAttribute('data-required-if')) return;

                    const elHasRelatedFields = name && formElements.filter(field => field.name === name).length > 1 || el.name == 'communities';

                    if (elHasRelatedFields) {
                        if (el.type === 'radio' && !el.id.startsWith("rdoOptInNo-")) {
                            if (el.checked) {
                                formData.push({ "id": id, "value": "true" })
                            }
                        }
                        else if (el.checked) {
                            communities.push(value);
                        }
                    }
                    else {
                        formData.push({ "id": id, "value": value });
                    }
                });

                const requiredGroups = formElements
                    .filter(el => el.hasAttribute('data-required-if'))
                    .reduce((_requiredGroups, el) => {
                        if (!_requiredGroups[el.dataset.requiredIf]) {
                            _requiredGroups[el.dataset.requiredIf] = [];
                        }
                        _requiredGroups[el.dataset.requiredIf].push(el);
                        return _requiredGroups;
                    }, {});

                Object.entries(requiredGroups).forEach(([name, elements]) => {
                    formData.push({ "id": name, "value": elements.every(el => el.checked) ? "true" : "false" });
                });

                const data = {
                    formData,
                    communities
                };

                console.log(data);
                return data;
            }
            const errorBack = () => {
                steps[currentStep].classList.remove('is-active');
                formTitle.style.display = 'none';
                errorMessage.classList.remove('hide');
                if (errorMessage.querySelector('.form__back-btn')) {
                    errorMessage.querySelector('.form__back-btn').addEventListener('click', () => {
                        if (i === currentStep) {
                            steps[currentStep].classList.add('is-active');
                            formTitle.style.display = 'block';
                        }
                        errorMessage.classList.add('hide');
                    });
                }
            }
            const doSubmit = (e) => {
                e.preventDefault();

                const data = getJsonData();

                document.body.style.cursor = 'wait';
                submitBtn.style.cursor = 'wait';
                submitBtn.disabled = true;
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) { //Check for the request to be complete
                        if (xhr.status === 200) { //Check for a successful return
                            var json = JSON.parse(xhr.responseText);
                            if (json.success) { //Check for success code
                                steps[currentStep].classList.remove('is-active');
                                successMessage.classList.remove('hide');
                                formTitle.style.display = 'none';
                                window.scroll({
                                    top: successMessage.offsetTop - 200,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                                console.log('success')
                            } else {
                                console.log(json);
                                errorBack();
                            }
                        }
                        else {
                            errorBack();
                        }
                    }
                    submitBtn.style.cursor = 'default';
                    document.body.style.cursor = 'default';
                    submitBtn.disabled = false;
                };
                xhr.send(JSON.stringify(data));

            }

            if (phoneNumber) {
                if (phoneNumber.value.length === 0 || phoneNumber === null) {
                    textMessages.style.display = 'none';
                    rdoTextOptInNo.checked = true;
                }
                this.$addEvents(phoneNumber, 'blur', () => {
                    if (phoneNumber.value.length === 0 || phoneNumber === null) {
                        textMessages.style.display = 'none';
                        rdoTextOptInNo.checked = true;
                    } else {
                        textMessages.style.display = 'block';
                        rdoTextOptInNo.checked = false;
                    }
                });
            }

            if (nextBtn || submitBtn) this.$validate(step, validationBtn);
            if (prevBtn) this.$addEvents(prevBtn, eventString, goToPrev);
            if (nextBtn) this.$addEvents(nextBtn, eventString, goToNext);
            if (submitBtn) this.$addEvents(submitBtn, eventString, doSubmit);
        });
    }
});


new Blue({
    name: 'MultiStep Form',
    selector: ".form--multi-step",
    setup(form) {
        const stepCount = form.querySelector('.form__step-increment');
        const steps = [...form.querySelectorAll('.form__step')];
        const totalSteps = steps.length;
        const eventString = 'click.prevent enter.prevent'
        const url = form.querySelector('#apiUrl').value;
        const successMessage = form.querySelector('.form__confirmation');
        const instructions = form.querySelector('.form__instructions');
        const phoneNumber = form.querySelector('#phoneNumber');
        const textMessages = form.querySelector('.text__messages');
        const rdoTextOptInNo = textMessages.querySelector('#rdoOptInNo-textOptInNo');

        let currentStep = 0;
        let nextStep;

        steps.forEach(step => {
            const prevBtn = step.querySelector('.form__back-btn');
            const nextBtn = step.querySelector('.form__next-btn');
            const submitBtn = step.querySelector('.form__input--submit');
            const validationBtn = nextBtn ? nextBtn : submitBtn;

            const goToPrev = () => {
                nextStep = currentStep - 1;
                if (nextStep < 0) return;
                steps[currentStep].classList.remove('is-active');
                steps[nextStep].classList.add('is-active');
                currentStep = nextStep;
                stepCount.textContent = currentStep + 1;
                window.scroll({
                    top: steps[nextStep].offsetTop - 150,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            const goToNext = () => {
                nextStep = currentStep + 1;
                if (currentStep === 0) {
                    doFirstSubmit();
                }
                if (nextStep >= totalSteps) return;
                steps[currentStep].classList.remove('is-active');
                steps[nextStep].classList.add('is-active');
                currentStep = nextStep;
                stepCount.textContent = currentStep + 1;
                window.scroll({
                    top: steps[nextStep].offsetTop - 150,
                    left: 0,
                    behavior: 'smooth'
                });
                if (currentStep === 2) {
                    if (phoneNumber.value.length === 0 || phoneNumber === null) {
                        textMessages.style.display = 'none';
                        rdoTextOptInNo.checked = true;
                    } else {
                        textMessages.style.display = 'block';
                        rdoTextOptInNo.checked = false;
                    }
                }
            }
            const doSubmit = () => {
                document.body.style.cursor = 'wait';
                submitBtn.style.cursor = 'wait';
                submitBtn.disabled = true;
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) { //Check for the request to be complete
                        if (xhr.status === 200) { //Check for a successful return
                            var json = JSON.parse(xhr.responseText);
                            if (json.success) {
                                steps[currentStep].classList.remove('is-active');
                                successMessage.classList.remove('hide');
                                instructions.style.display = 'none';
                                window.scroll({
                                    top: successMessage.offsetTop - 200,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                            }
                            else {
                                console.log(json);
                                var errors = json.errors.join(',');
                                alert("System Error: " + errors);
                            }
                        }
                    }
                    submitBtn.style.cursor = 'default';
                    document.body.style.cursor = 'default';
                    submitBtn.disabled = false;
                };
                xhr.send(JSON.stringify(getJsonLastSubmit()));

            }
            const doFirstSubmit = () => {
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        var json = JSON.parse(xhr.responseText);
                        form.querySelector('#SFID').value = json.id;
                    }
                };
                xhr.send(JSON.stringify(getJsonFirstSubmit()));
            }
            const getJsonFirstSubmit = () => {
                let els = form.querySelectorAll("input[name='interest']");
                var interests = [];
                interests.push(form.querySelector('#Interest').value);
                var i = 0;
                for (i = 0; i < els.length; ++i) {
                    if (els[i].checked) {
                        interests.push(els[i].value);
                    }
                }
                var sendMeMoreInformation = false;
                if (form.querySelector("#terms")) {
                    if (form.querySelector("#terms").checked) {
                        sendMeMoreInformation = true
                    };
                }
                return {
                    Step: 1,
                    PropertyCode: form.querySelector('#PropertyCode').value,
                    FirstName: form.querySelector('#firstName').value,
                    LastName: form.querySelector('#lastName').value,
                    Email: form.querySelector('#emailAddress').value,
                    MoveDate: form.querySelector('#moveDate') ? form.querySelector('#moveDate').value : null,
                    SendMeMoreInformation: sendMeMoreInformation,
                    MarketPropertyList: interests,
                    SFID: form.querySelector('#SFID').value,
                    referrer: document.referrer
                }
            }
            const getJsonLastSubmit = () => {
                let els = form.querySelectorAll("input[name='interest']");
                var interests = [];
                interests.push(form.querySelector('#Interest').value);
                var i = 0;
                for (i = 0; i < els.length; ++i) {
                    if (els[i].checked) {
                        interests.push(els[i].value);
                    }
                }

                var sendMeTextMessages = false;
                if (form.querySelector("#confirmTextOptIn").checked === true) {
                    sendMeTextMessages = true
                };
                var confirmTextOptIn = false;
                if (form.querySelector("#confirmTextOptIn1").checked === true) {
                    confirmTextOptIn = true
                };
                var phoneNumber = form.querySelector('#phoneNumber').value;

                return {
                    Step: 3,
                    PropertyCode: form.querySelector('#PropertyCode').value,
                    FirstName: form.querySelector('#firstName').value,
                    LastName: form.querySelector('#lastName').value,
                    Email: form.querySelector('#emailAddress').value,
                    InternationalCode: form.querySelector('#internationalCode').value,
                    Address: form.querySelector('#address').value,
                    City: form.querySelector('#city').value,
                    State: form.querySelector('#ddlStates').value,
                    ZipCode: form.querySelector('#zipCode').value,
                    Country: form.querySelector('#ddlCountry').value,
                    HearAbout: form.querySelector('#ddlHearAbout').value,
                    Referrer: document.referrer,
                    Phone: phoneNumber,
                    MarketPropertyList: interests,
                    SendMeTextMessages: sendMeTextMessages,
                    TextOptIn: confirmTextOptIn,
                    MoveDate: form.querySelector('#moveDate') ? form.querySelector('#moveDate').value : null,
                    SFID: form.querySelector('#SFID').value
                }
            }

            this.$validate(step, validationBtn);
            if (prevBtn) this.$addEvents(prevBtn, eventString, goToPrev)
            if (nextBtn) this.$addEvents(nextBtn, eventString, goToNext)
            if (submitBtn) this.$addEvents(submitBtn, eventString, (doSubmit))
        });
    }
});


new Blue({
    name: 'Form Text Messages',
    selector: ".form",
    setup(form) {
        const formWrapper = form.querySelector('.form__wrapper');
        const message = form.querySelector('.form__text-messages');
        const message1 = form.querySelector('.form__text-messages1');
        const submitButton = form.querySelector('.form__input--submit');
        const confirmation = form.querySelector('.form__confirmation');
        const errormessage = form.querySelector('.form__errormessage');


        //if opt-in then require the confirm checkbox
        const phoneNumber = form.querySelector('#phoneNumber');
        const rdoTextOptInYes = form.querySelector('#rdoTextOptInYes');
        const rdoTextOptInNo = form.querySelector('#rdoOptInNo-textOptInNo');
        const confirmTextOptIn = form.querySelector('#confirmTextOptIn');
        const confirmTextOptIn1 = form.querySelector('#confirmTextOptIn1');

        if (rdoTextOptInYes != null && rdoTextOptInNo != null && confirmTextOptIn != null) {
            if (phoneNumber != null) {
                this.$addEvents(phoneNumber, "change", () => {
                    if (rdoTextOptInYes.checked) {
                        const textMessagesFormErrorRequiredPhone = document.querySelector(".form__text-messages--requiredphone .formError");
                        if (textMessagesFormErrorRequiredPhone != null) {
                            if (phoneNumber.value.trim() == "") {
                                textMessagesFormErrorRequiredPhone.removeAttribute("hidden");
                            } else {
                                textMessagesFormErrorRequiredPhone.setAttribute("hidden", "hidden");
                            }
                        }
                    }
                });
            }
            this.$addEvents(rdoTextOptInYes, "change", () => {
                if (rdoTextOptInYes.checked) {
                    message.classList.add('show');
                    message1.classList.add('show');
                    confirmTextOptIn.checked = false;
                    confirmTextOptIn1.checked = false;
                    confirmTextOptIn.setAttribute("required", "required");
                    confirmTextOptIn1.setAttribute("required", "required");

                    const textMessagesFormErrorRequiredPhone = document.querySelector(".form__text-messages--requiredphone .formError");
                    if (phoneNumber != null && textMessagesFormErrorRequiredPhone != null) {
                        if (phoneNumber.value.trim() == "") {
                            textMessagesFormErrorRequiredPhone.removeAttribute("hidden");
                        } else {
                            textMessagesFormErrorRequiredPhone.setAttribute("hidden", "hidden");
                        }
                    }
                }

            });
            this.$addEvents(rdoTextOptInNo, "change", () => {
                if (rdoTextOptInNo.checked) {
                    message.classList.remove('show');
                    message1.classList.remove('show');
                    confirmTextOptIn.checked = false;
                    confirmTextOptIn1.checked = false;
                    confirmTextOptIn.removeAttribute("required");
                    confirmTextOptIn1.removeAttribute("required");

                    //text message needs phone number
                    const textMessagesFormErrorRequiredPhone = document.querySelector(".form__text-messages--requiredphone .formError");
                    if (textMessagesFormErrorRequiredPhone != null) {
                        textMessagesFormErrorRequiredPhone.setAttribute("hidden", "hidden");
                    }
                }
            });
        }
        if (submitButton) {
            this.$addEvents(submitButton, 'click', (event) => {
                let hasCustomErrors = false;
                //require at least 1 market option to be selected
                const marketOptionsFormError = document.querySelector(".form__marketoptions .formError");
                if (marketOptionsFormError != null) {
                    marketOptionsFormError.setAttribute("hidden", "hidden");
                    var marketoptions = document.querySelectorAll('input[name=marketoption]');
                    if (marketoptions != null && marketoptions.length > 0) {
                        var checkedMarketoptions = [].filter.call(marketoptions, function (el) { return el.checked; });
                        if (checkedMarketoptions.length == 0) {
                            hasCustomErrors = true;
                            marketOptionsFormError.removeAttribute("hidden");
                        }
                    }
                }
                //text message needs phone number
                const textMessagesFormErrorRequiredPhone = document.querySelector(".form__text-messages--requiredphone .formError");
                if (textMessagesFormErrorRequiredPhone != null) {
                    textMessagesFormErrorRequiredPhone.setAttribute("hidden", "hidden");
                    if ((rdoTextOptInYes != null && rdoTextOptInYes.checked) && (phoneNumber != null && phoneNumber.value.trim() == "")) {
                        hasCustomErrors = true;
                        textMessagesFormErrorRequiredPhone.removeAttribute("hidden");
                    }
                }
                //if opt-in then require confirmation
                const textMessagesFormError = document.querySelector(".form__text-messages .formError");
                if (textMessagesFormError != null) {
                    textMessagesFormError.setAttribute("hidden", "hidden");
                    if (rdoTextOptInYes != null && confirmTextOptIn != null) {
                        if (rdoTextOptInYes.checked && !confirmTextOptIn.checked) {
                            hasCustomErrors = true;
                            textMessagesFormError.removeAttribute("hidden");
                        }
                    }
                }
                const textMessagesFormError1 = document.querySelector(".form__text-messages1 .formError");
                if (textMessagesFormError1 != null) {
                    textMessagesFormError1.setAttribute("hidden", "hidden");
                    if (rdoTextOptInYes != null && confirmTextOptIn1 != null) {
                        if (rdoTextOptInYes.checked && !confirmTextOptIn1.checked) {
                            hasCustomErrors = true;
                            textMessagesFormError1.removeAttribute("hidden");
                        }
                    }
                }
            })
        }
    }
});

new Blue({
    name: 'Form Property Splash',
    selector: ".form--property-splash",
    setup(form) {
        const formWrapper = form.querySelector('.form__wrapper');
        const errorMessage = form.querySelector('.form__errormessage');
        const submitButton = form.querySelector('.form__input--submit');
        const confirmation = form.querySelector('.form__confirmation');

        errorMessage.classList.add('hide');
        confirmation.classList.add('hide');

        const url = form.querySelector('#apiUrl') ? form.querySelector('#apiUrl').value : null;

        //if opt-in then require the confirm checkbox
        const firstName = form.querySelector('#firstName');
        const lastName = form.querySelector('#lastName');
        const emailAddress = form.querySelector('#emailAddress');

        if (submitButton) {
            this.$validate(form, submitButton);
            this.$addEvents(submitButton, 'click', (e) => {
                e.preventDefault();
         
                let contactUsPropertiesArray = [];
                const contactUsProperties = form.querySelector('#ContactUsProperties').value;
                if (contactUsProperties) {
                    contactUsPropertiesArray =  contactUsProperties.split(",");
                }

                var sendMeMoreInformation = false;
                if (form.querySelector("#terms")) {
                    if (form.querySelector("#terms").checked) {
                        sendMeMoreInformation = true
                    };
                }
                const guestCardData = {
                    Step: 1,
                    PropertyCode: form.querySelector('#PropertyCode').value,
                    FirstName: form.querySelector('#firstName').value,
                    LastName: form.querySelector('#lastName').value,
                    Email: form.querySelector('#emailAddress').value,
                    SFID: form.querySelector('#SFID').value,
                    MarketPropertyList: contactUsPropertiesArray,
                    SendMeMoreInformation: sendMeMoreInformation,
                    MoveDate: form.querySelector('#moveDate') ? form.querySelector('#moveDate').value : null,
                }
                const postData = { guestCardData };
                errorMessage.classList.add('hide');
                confirmation.classList.add('hide');
                document.body.style.cursor = 'wait';
                submitButton.style.cursor = 'wait';
                submitButton.disabled = true;
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) { //Check for the request to be complete
                        if (xhr.status === 200) { //Check for a successful return
                            var json = JSON.parse(xhr.responseText);
                            if (json.success) { //Check for success code
                   
                                formWrapper.classList.add('hide');
                                confirmation.classList.remove('hide');
                               
                       
                            } else {
                                errorMessage.classList.remove('hide');
                         
                            }
                        }
                        else {
                    
                            errorMessage.classList.remove('hide');
                        }
                    }
                    submitButton.style.cursor = 'default';
                    document.body.style.cursor = 'default';
                    submitButton.disabled = false;
                };
                xhr.send(JSON.stringify(guestCardData));
            });
        }
    }
});
